import { Outlet } from "react-router-dom";
import Navbar from "../Navbar";
import React, { useState } from "react";
import clsx from "clsx";
import { useLocation } from "react-router-dom";
import Footer from "../Footer";
import ContactFormModal from "../common/ContactModal";

const MainLayout: React.FC = () => {
  const [showContactModal, setShowContactModal] = useState<boolean>(false);
  const { pathname } = useLocation();

  const toggleContactModal = () => {
    setShowContactModal((prev) => !prev);
  };

  return (
    <div className="flex justify-center w-full">
      <main className="min-h-screen max-w-[1900px] overflow-hidden flex flex-col w-full">
        <header className="w-full">
          <Navbar toggleContact={toggleContactModal} />
        </header>
        <div
          className={clsx("flex-1 w-full min-h-screen", {
            "pt-[4rem]": pathname !== "/" && pathname !== "/aboutus",
          })}
        >
          <Outlet />
        </div>
        <ContactFormModal
          isOpen={showContactModal}
          onClose={toggleContactModal}
        />
        <footer>
          <Footer />
        </footer>
      </main>
    </div>
  );
};

export default MainLayout;
